import { useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import Label from "./Label";

const CityInputDropdown = ({
    label,
    name,
    id,
    value,
    onChange,
    placeholder,
    loading,
    required = false,
    className = '',
    labelClass = '',
    options = [],
    'data-testid': dataTestId,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const testId = dataTestId ?? (name ? `${name}-input` : 'input');

    const handleSelect = (selectedOption) => {
    onChange({ target: { name, value: selectedOption.name } }, 'dropdown', selectedOption);
    setIsOpen(false);
};

    return (
        <div className="relative flex flex-col gap-1">
      {label && <Label htmlFor={name} data-testid={name ? `${name}-label` : undefined} className={labelClass}>{label}</Label>}

      {/* Input with dropdown icon */}
      <div className="relative w-full">
        <input
          data-testid={testId}
          type="text"
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 150)} // delay to select option
          placeholder={placeholder}
          required={required}
          className={`${className} pr-10`}
          autoComplete="off"
        />

        {/* Dropdown arrow */}
        <div
          className="absolute inset-y-0 right-2 items-center cursor-pointer hidden"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
            <path d="M19 9L12 15L5 9" stroke="black" strokeOpacity="0.87" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="dark:stroke-white"/>
          </svg>
        </div>
        {loading && <LoadingSpinner size='small' className='absolute right-1 top-3.5'/> }
      </div>

      {/* Dropdown list */}
      {isOpen && options.length > 0 && (
        <div className="dropdownMenuHolder absolute top-full right-0 shadow-appShadow block w-full rounded-md z-50 dark:shadow-darkThemeDropdownMenuShadow  dark:bg-darkThemeDropdownBg">
          <ul data-testid={`${testId}-options`} className="mt-1 z-10 w-full bg-white dark:bg-darkThemeDropdownBg dark:border-0 border border-gray-300 rounded-md shadow-md max-h-32 overflow-y-auto">
            {options.map((option, index) => {
              const isSelected = option.name === value;
              return (
                <li
                  key={index}
                  data-testid={`${testId}-option-${index}`}
                  onMouseDown={() => handleSelect(option)}
                  className={`px-3 py-2.5 text-dark-grey dark:text-white text-xs leading-4 lg:text-sm font-normal tracking-[-0.408px] border-b border-grey dark:border-darkThemeBorder last:border-0 flex justify-between items-center gap-2 cursor-pointer ${isSelected ? 'bg-[#FFF1C6] dark:bg-darkThemeDropdownItemBg' : 'bg-white dark:bg-darkThemeDropdownBg'}`}
                >
                  <span>{option.name}</span>
                  {isSelected && (
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                        <path d="M8.49 15c-.25 0-.49-.1-.66-.28L4.27 11.17a.942.942 0 0 1 1.33-1.33l2.89 2.89 6.45-6.45a.942.942 0 0 1 1.33 1.33l-7.12 7.12c-.17.18-.41.28-.66.28Z" fill="#FF8C65" />
                      </svg>
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}

        </div>
    );
};

export default CityInputDropdown;
